"use client"

import TourInclusions, { TourInclusion } from "@/components/TourInclusion";



export default function TourInclusionPage() {
  return (
    <div>
     <TourInclusion/>
    </div>
  )
}
